module.exports = __webpack_public_path__ + "img/cart_big.ba4781c7.svg";